import { gql, useQuery } from '@apollo/client';
import { toaster } from 'evergreen-ui';
import { getErrorMessage } from '../helpers/functions';

export const defaultCurrencyTemp = {
  CurrencyDescription: 'British Pounds',
  CurrencyId: 2,
  CurrencyShortcode: 'GBP',
  CurrencySymbol: '£',
  DateCreated: '2012-10-09T14:32:34.643',
  IsActive: true,
  IsAllowMerchant: false,
  TicketAdminBase: 1,
  TicketAdminPercentage: 12.5,
  __typename: 'CurrencyDetails',
  label: 'GBP',
  value: 2,
  symbol: '£',
};

const CURRENCIES_QUERY = gql`
  query CurrencyDetailsQuery {
    CurrencyDetails: allCurrencyDetaill(where: { isActive: { eq: true } }) {
      CurrencyDetails: items {
        CurrencyId: currencyId
        CurrencySymbol: currencySymbol
        CurrencyShortcode: currencyShortcode
        IsActive: isActive
        CurrencyDescription: currencyDescription
        DateCreated: dateCreated
        TicketAdminBase: ticketAdminBase
        TicketAdminPercentage: ticketAdminPercentage
        IsAllowMerchant: isAllowMerchant
      }
      totalCount
    }
  }
`;

function useCurrencies() {
  return useQuery(CURRENCIES_QUERY, {
    fetchPolicy: 'network-only',
    onError: (error) => {
      toaster.danger(getErrorMessage(error), {
        id: 'fetch-currencies-error',
        description: 'An error occurred while fetching list of currencies.',
      });
    },
  });
}

export function useSingleCurrency() {
  const { data: currencies } = useCurrencies();

  return (key, value, responseKey) =>
    currencies?.CurrencyDetails?.CurrencyDetails?.filter(
      (currency) => currency[key] === value
    )?.[0]?.[responseKey];
}

export default useCurrencies;
